import { twMerge } from "tailwind-merge";

import { GridProps } from "../types/GridBlockTypes";
import { PageBody } from "./PageBody";

const COLUMN_CLASSES = {
  "2": "md:grid-cols-2",
  "3": "md:grid-cols-2 lg:grid-cols-3",
  "4": "md:grid-cols-2 lg:grid-cols-4",
};

export const Grid = ({ columns, body }: GridProps) => {
  return (
    <div
      className={twMerge(
        "mb-4 grid grid-cols-1 gap-x-4 gap-y-8",
        COLUMN_CLASSES[columns]
      )}
    >
      {body.map((block) => (
        <div key={block._uid} className="w-full">
          <PageBody blok={[block]} />
        </div>
      ))}
    </div>
  );
};
